import React from 'react';
import SEOHead from './SEOHead';
import BreadcrumbsNav from './BreadcrumbsNav';
import { getToolSEO } from '../data/toolSEOData';
import { findTool, findToolCategory } from '../data/toolsData';

interface SEORouteProps {
  path: string;
  children: React.ReactNode;
}

export default function SEORoute({ path, children }: SEORouteProps) {
  const seo = getToolSEO(path);
  const tool = findTool(path);
  const category = findToolCategory(path);

  return (
    <>
      <SEOHead
        title={seo.title}
        description={seo.description}
        path={path}
        keywords={seo.keywords}
      />
      {tool && category && (
        <BreadcrumbsNav toolName={tool.name} category={category} />
      )}
      {children}
    </>
  );
}
